import { register } from '@shopify/theme-sections'

import '../../styles/sections/section-table-info.scss'

import $ from 'jquery'

export default register(`section-table-info`, {

  onLoad() {
  },

  onUnload() {
  },
})
